import { z } from 'zod';

export const ChartTipSchema = z
  .object({
    id: z.number().int(),
    suggestion: z.string(),
    is_active: z.boolean(),
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
  })
  .transform((raw) => ({
    id: raw.id,
    suggestion: raw.suggestion,
    isActive: raw.is_active,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export const ChartTipsResponseSchema = z.object({
  items: z.array(ChartTipSchema),
  total: z.number().int().nonnegative(),
});

export type ChartTipEntityApi = z.input<typeof ChartTipSchema>;
export type ChartTipEntity = z.infer<typeof ChartTipSchema>;
export type ChartTipsResponseApi = z.input<typeof ChartTipsResponseSchema>;
export type ChartTipsResponse = z.infer<typeof ChartTipsResponseSchema>;
